(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[732],{

/***/ 1301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2903);




function PageMeta(props) {
  var _props$description;

  var title = props.title;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("title", {
      children: title
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: title,
      property: "og:title"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: "ChatSift",
      property: "og:site_name"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: "/assets/chatsift.png",
      property: "og:image"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : 'A powerful solution for your day-to-day moderation bot needs.',
      property: "description"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      name: "theme-color",
      content: "#318EEE"
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);

/***/ }),

/***/ 1106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _name_; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(2746);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(2173);
// EXTERNAL MODULE: ./src/components/Text/index.tsx + 1 modules
var Text = __webpack_require__(2762);
// EXTERNAL MODULE: ./src/stitches/stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(8325);
;// CONCATENATED MODULE: ./src/components/BotUpsellCard/style.ts



var Card = (0,stitches_config/* styled */.zo)(Link/* RouterLink */.r, {
  displayFlex: 'column',
  borderRadius: stitches_config/* theme.radii.lg */.rS.radii.lg,
  padding: stitches_config/* theme.space.lg */.rS.space.lg,
  width: '100%',
  height: '100%',
  gap: stitches_config/* theme.space.md */.rS.space.md,
  backgroundColor: stitches_config/* theme.colors.bgCard */.rS.colors.bgCard,
  borderThin: stitches_config/* theme.colors.onBgSecondary */.rS.colors.onBgSecondary,
  variants: {
    cardWidth: {
      fixed: {
        width: '293px'
      },
      full: {
        width: '100%'
      }
    }
  }
});
var Header = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'row',
  justifyContent: 'space-between',
  gap: stitches_config/* theme.space.md */.rS.space.md
});
var BotTag = (0,stitches_config/* styled */.zo)(Text/* Text */.x, {
  displayFlex: 'row',
  alignItems: 'center',
  gap: stitches_config/* theme.space.xs */.rS.space.xs
});
// EXTERNAL MODULE: ./src/data/bots/index.ts + 3 modules
var bots = __webpack_require__(3402);
// EXTERNAL MODULE: ./src/svg/SvgLinkExternal.tsx
var SvgLinkExternal = __webpack_require__(9892);
// EXTERNAL MODULE: ./src/utils/urls.ts
var urls = __webpack_require__(1256);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
;// CONCATENATED MODULE: ./src/components/BotUpsellCard/index.tsx










function BotUpsellCard(_ref) {
  var bot = _ref.bot,
      pathName = _ref.pathName;
  var Icon = bots/* botIcons */.j[pathName];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card, {
    href: (0,urls/* botPage */.i6)(pathName),
    cardWidth: {
      '@initial': 'full',
      '@dashboardMaxWidth': 'fixed'
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Header, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BotTag, {
        kind: "heading4",
        color: "primary",
        weight: "bold",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
          width: 24,
          height: 24
        }), bot.name]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgLinkExternal/* default */.Z, {
        themeColor: stitches_config/* theme.colors.textSecondary.toString */.rS.colors.textSecondary.toString()
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
      children: bot.description.otherBotUpsell
    })]
  });
}

/* harmony default export */ var components_BotUpsellCard = (BotUpsellCard);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(6556);
// EXTERNAL MODULE: ./src/components/ButtonLink/index.tsx
var ButtonLink = __webpack_require__(4748);
// EXTERNAL MODULE: ./src/components/Footer/index.tsx + 5 modules
var Footer = __webpack_require__(1127);
// EXTERNAL MODULE: ./src/components/Heading/index.tsx + 1 modules
var Heading = __webpack_require__(3621);
;// CONCATENATED MODULE: ./src/components/ImageSlideshow/style.ts

var slideshowInterval = 3000;
var SlideshowContainer = (0,stitches_config/* styled */.zo)('div', {
  overflow: 'hidden',
  variants: {
    hasGradient: {
      "true": {
        WebkitMaskImage: '-webkit-gradient(linear, 60% top, right top, from(rgba(0, 0, 0, 1)), to(rgba(0, 0, 0, 0)))'
      }
    }
  }
});
var Slideshow = (0,stitches_config/* styled */.zo)('ul', {
  displayFlex: 'row',
  gap: 'var(--slideshow-gap)',
  width: 'max-content',
  marginRight: 'var(--slideshow-gap)'
});
var Image = (0,stitches_config/* styled */.zo)('img', {
  backgroundColor: stitches_config/* theme.colors.onBgSecondary */.rS.colors.onBgSecondary
});
var ImageContainer = (0,stitches_config/* styled */.zo)('li', {
  position: 'relative',
  maxWidth: 'var(--width-one-item)',
  width: '100%',
  borderRadius: stitches_config/* theme.radii.lg */.rS.radii.lg,
  borderWidth: 2,
  borderStyle: stitches_config/* theme.borderStyles.normal */.rS.borderStyles.normal,
  borderColor: stitches_config/* theme.colors.onBgSecondary */.rS.colors.onBgSecondary,
  overflow: 'hidden',
  objectFit: 'contain'
});
// EXTERNAL MODULE: ./src/styles/breakpoints.ts
var breakpoints = __webpack_require__(3808);
;// CONCATENATED MODULE: ./src/components/ImageSlideshow/index.tsx






function ImageSlideshow(_ref) {
  var images = _ref.images,
      imageWidths = _ref.imageWidths;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
      children: "\n\t\t\t\t\t:root {\n\t\t\t\t\t\t--width-one-item: ".concat(imageWidths.small, "px;\n\t\t\t\t\t\t--n-images: ").concat(images.length, ";\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t").concat(breakpoints/* default.smallMin */.ZP.smallMin, " {\n\t\t\t\t\t\t:root {\n\t\t\t\t\t\t\t--width-one-item: ").concat(imageWidths.medium, "px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t").concat(breakpoints/* default.dashboardMaxWidthMin */.ZP.dashboardMaxWidthMin, " {\n\t\t\t\t\t\t:root {\n\t\t\t\t\t\t\t--width-one-item: ").concat(imageWidths.large, "px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t").replace(/\s/g, '')
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SlideshowContainer, {
      hasGradient: {
        '@initial': false,
        '@dashboardMaxWidth': true
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Slideshow, {
        style: {
          animation: "slideshow-slide ".concat(slideshowInterval * images.length, "ms linear infinite, slideshow-grow ").concat(slideshowInterval, "ms linear infinite")
        },
        children: [images.map(function (image, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
              src: image.url,
              alt: image.alt
            })
          }, index);
        }), images.map(function (image, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
              src: image.url,
              alt: image.alt
            })
          }, index);
        })]
      })
    })]
  });
}

/* harmony default export */ var components_ImageSlideshow = (ImageSlideshow);
// EXTERNAL MODULE: ./src/components/PageMeta/index.tsx
var PageMeta = __webpack_require__(1301);
;// CONCATENATED MODULE: ./src/components/Review/style.ts

var Base = (0,stitches_config/* styled */.zo)('figure', {
  displayFlex: 'column',
  justifyContent: 'space-between',
  padding: stitches_config/* theme.space.lg */.rS.space.lg,
  borderRadius: stitches_config/* theme.radii.lg */.rS.radii.lg,
  backgroundColor: stitches_config/* theme.colors.bgCard */.rS.colors.bgCard,
  borderThin: stitches_config/* theme.colors.onBgSecondary */.rS.colors.onBgSecondary,
  variants: {
    height: {
      small: {
        height: 152
      },
      medium: {
        height: 164
      },
      large: {
        height: 200
      }
    }
  }
});
var Author = (0,stitches_config/* styled */.zo)('figcaption', {
  displayFlex: 'row',
  gap: stitches_config/* theme.space.sm */.rS.space.sm,
  alignItems: 'center'
});
var AuthorAvatar = (0,stitches_config/* styled */.zo)('img', {
  width: stitches_config/* theme.sizes.mediumImage */.rS.sizes.mediumImage,
  height: stitches_config/* theme.sizes.mediumImage */.rS.sizes.mediumImage,
  borderRadius: stitches_config/* theme.radii.rounded */.rS.radii.rounded
});
;// CONCATENATED MODULE: ./src/components/Review/index.tsx





function Review(review) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Base, {
    height: {
      '@initial': 'large',
      '@small': 'medium',
      '@dashboardMaxWidth': 'small'
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
      color: "primary",
      children: review.content
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Author, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorAvatar, {
        src: review.author.avatarUrl
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
          weight: "bold",
          color: "primary",
          children: review.author.name
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
          children: review.author.role
        })]
      })]
    })]
  });
}

/* harmony default export */ var components_Review = (Review);
;// CONCATENATED MODULE: ./src/components/SingleItemPaginator/style.ts

var noJsControlsGap = '8px';
var noJsControlSize = '16px';
var style_Base = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'column',
  gap: stitches_config/* theme.space.lg */.rS.space.lg
});
var Content = (0,stitches_config/* styled */.zo)('div', {
  display: 'grid',
  flexDirection: 'row',
  minWidth: '100%'
});
var ControlsArrows = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: stitches_config/* theme.space.xs */.rS.space.xs
});
var ControlsNoJs = (0,stitches_config/* styled */.zo)('div', {
  display: 'none',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  marginBottom: stitches_config/* theme.space.xxl */.rS.space.xxl
});
var NoJsPageRadioButton = (0,stitches_config/* styled */.zo)('input', {
  position: 'absolute',
  bottom: "calc(".concat(stitches_config/* theme.space.xxl */.rS.space.xxl, " * -1)"),
  width: noJsControlSize,
  height: noJsControlSize,
  appearance: 'none',
  backgroundColor: stitches_config/* theme.colors.textDisabled */.rS.colors.textDisabled,
  borderRadius: '100%',
  scale: 0.9,
  opacity: 0.7,
  transition: 'background-color 0.2s ease-in-out, scale 0.2s ease-in-out',
  cursor: 'pointer',
  '&:hover': {
    scale: 1,
    backgroundColor: stitches_config/* theme.colors.textSecondary */.rS.colors.textSecondary
  },
  '&:checked': {
    scale: 1.1,
    backgroundColor: stitches_config/* theme.colors.textPrimary */.rS.colors.textPrimary
  }
});
;// CONCATENATED MODULE: ./src/svg/SvgNext.tsx


function SvgNext(_ref) {
  var _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? 'currentColor' : _ref$themeColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12ZM10 18L16 12L10 6L8.6 7.4L13.2 12L8.6 16.6L10 18Z",
      fill: themeColor
    })
  });
}

/* harmony default export */ var svg_SvgNext = (SvgNext);
;// CONCATENATED MODULE: ./src/svg/SvgPrev.tsx


function SvgPrev(_ref) {
  var _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? 'currentColor' : _ref$themeColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12ZM15.4 16.6L10.8 12L15.4 7.4L14 6L8 12L14 18L15.4 16.6Z",
      fill: themeColor
    })
  });
}

/* harmony default export */ var svg_SvgPrev = (SvgPrev);
;// CONCATENATED MODULE: ./src/components/SingleItemPaginator/index.tsx











function SingleItemPaginator(_ref) {
  var children = _ref.children;
  var numPages = react.Children.count(children);
  var maxPage = numPages - 1;

  var _useState = (0,react.useState)(0),
      page = _useState[0],
      setPage = _useState[1];

  var randId = (0,react.useId)();

  function prev() {
    if (page > 0) {
      setPage(page - 1);
      return;
    }

    setPage(maxPage);
  }

  function next() {
    if (page === maxPage) {
      setPage(0);
      return;
    }

    setPage(page + 1);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(style_Base, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("noscript", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
        children: "\n\t\t\t\t\t\t.hide-no-js {\n\t\t\t\t\t\t\tdisplay: none !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t.controls-no-js {\n\t\t\t\t\t\t\tdisplay: flex !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t".replace(/\s/g, '')
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
      className: "hide-no-js",
      children: react.Children.toArray(children)[page]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ControlsNoJs, {
      className: "controls-no-js",
      children: react.Children.map(children, function (_, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoJsPageRadioButton, {
            id: "paginator-btn-".concat(randId, "-").concat(index),
            type: "radio",
            name: randId,
            title: "Page ".concat(index + 1),
            style: {
              left: "calc(50% - (".concat(numPages, " * (").concat(noJsControlSize, " + ").concat(noJsControlsGap, ")) / 2 + ").concat(index, " * (").concat(noJsControlSize, " + ").concat(noJsControlsGap, ") + ").concat(noJsControlsGap, " / 2)")
            },
            defaultChecked: index === 0
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
            id: "paginator-content-".concat(randId, "-").concat(index),
            children: react.Children.toArray(children)[index]
          })]
        }, "radio-".concat(index));
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ControlsArrows, {
      className: "hide-no-js",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
        buttonType: "ghost",
        form: "extraSmall",
        onPress: prev,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(svg_SvgPrev, {
          themeColor: stitches_config/* theme.colors.textDisabled.toString */.rS.colors.textDisabled.toString()
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
        color: "primary",
        children: [page + 1, " of ", maxPage + 1]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
        buttonType: "ghost",
        form: "extraSmall",
        onPress: next,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(svg_SvgNext, {
          themeColor: stitches_config/* theme.colors.textDisabled.toString */.rS.colors.textDisabled.toString()
        })
      })]
    })]
  });
}

/* harmony default export */ var components_SingleItemPaginator = (SingleItemPaginator);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(9526);
;// CONCATENATED MODULE: ./src/pages/bot/[name].tsx




var _globalCss;



















var hideOnDevices = (0,stitches_config/* globalCss */.zY)((_globalCss = {}, (0,defineProperty/* default */.Z)(_globalCss, "@media (max-width: ".concat(breakpoints/* mediaQueriesRaw.dashboardMaxWidth */.WX.dashboardMaxWidth, "px)"), {
  '[data-hide-on-mobile]': {
    display: 'none !important'
  }
}), (0,defineProperty/* default */.Z)(_globalCss, "@media (min-width: ".concat(breakpoints/* mediaQueriesRaw.dashboardMaxWidth */.WX.dashboardMaxWidth, "px)"), {
  '[data-hide-on-desktop]': {
    display: 'none !important'
  }
}), _globalCss));
var Container = (0,stitches_config/* styled */.zo)('main', {
  displayFlex: 'column',
  paddingTop: stitches_config/* theme.space.lg */.rS.space.lg,
  flex: '1 0 auto',
  width: '80vw',
  gap: stitches_config/* theme.space.huge */.rS.space.huge,
  alignItems: 'stretch',
  variants: {
    mobile: {
      "true": {
        maxWidth: constants/* smallestDashboardWidth */.EH - constants/* dashboardPadding */.SP * 2
      },
      "false": {
        maxWidth: constants/* dashboardMaxWidth */.AA
      }
    }
  }
});
var Cta = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'column',
  gap: stitches_config/* theme.space.md */.rS.space.md,
  marginTop: stitches_config/* theme.space.xxl */.rS.space.xxl
});
var CtaButtons = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'row',
  gap: stitches_config/* theme.space.lg */.rS.space.lg
});
var CtaTextContainer = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'column'
});
var Features = (0,stitches_config/* styled */.zo)('ul', {
  display: 'grid',
  gap: stitches_config/* theme.space.xl */.rS.space.xl,
  marginTop: stitches_config/* theme.space.lg */.rS.space.lg,
  variants: {
    columns: {
      one: {
        gridTemplateColumns: '1fr'
      },
      two: {
        gridTemplateColumns: '1fr 1fr'
      }
    }
  }
});
var Feature = (0,stitches_config/* styled */.zo)('li', {
  padding: stitches_config/* theme.space.lg */.rS.space.lg,
  displayFlex: 'column',
  gap: stitches_config/* theme.space.sm */.rS.space.sm,
  backgroundColor: stitches_config/* theme.colors.bgCard */.rS.colors.bgCard,
  borderThin: stitches_config/* theme.colors.onBgSecondary */.rS.colors.onBgSecondary,
  borderRadius: stitches_config/* theme.radii.lg */.rS.radii.lg
});
var FeatureName = (0,stitches_config/* styled */.zo)(Text/* Text */.x, {
  '&::before': {
    color: stitches_config/* theme.colors.miscAccent */.rS.colors.miscAccent,
    marginRight: stitches_config/* theme.space.sm */.rS.space.sm,
    content: '•'
  }
});
var BotList = (0,stitches_config/* styled */.zo)('ul', {
  display: 'flex',
  gap: stitches_config/* theme.space.lg */.rS.space.lg,
  variants: {
    direction: {
      column: {
        flexDirection: 'column'
      },
      row: {
        flexDirection: 'row'
      }
    }
  }
});
var SectionHeader = (0,stitches_config/* styled */.zo)('div', {
  marginBottom: stitches_config/* theme.space.lg */.rS.space.lg
});
var SectionTitle = (0,stitches_config/* styled */.zo)(Text/* Text */.x, {
  '&:not(:last-child)': {
    marginBottom: stitches_config/* theme.space.sm */.rS.space.sm
  }
});
var DonationUpsellSection = (0,stitches_config/* styled */.zo)('section', {
  display: 'flex',
  gap: stitches_config/* theme.space.xl */.rS.space.xl,
  variants: {
    direction: {
      column: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
      },
      row: {
        flexDirection: 'row',
        alignItems: 'center'
      }
    }
  }
});

function BotPage(_ref) {
  var bot = _ref.bot;
  hideOnDevices();

  if (bot === undefined) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageMeta/* default */.Z, {
        title: "Bot not found"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
        mobile: {
          '@initial': true,
          '@dashboardMaxWidth': false
        },
        children: "Unknown bot"
      })]
    });
  }

  var otherBots = Object.entries(bots/* default */.Z).filter(function (_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
        b = _ref3[1];

    return b.name !== bot.name;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageMeta/* default */.Z, {
      title: bot.name,
      description: bot.description.card
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
      mobile: {
        '@initial': true,
        '@dashboardMaxWidth': false
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ImageSlideshow, {
          images: bot.slideshowImages,
          imageWidths: bot.slideshowImageWidths
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Cta, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
            kind: "title",
            color: "primary",
            weight: "bold",
            children: bot.pageTitle
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaTextContainer, {
            children: bot.description.page.map(function (line, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                children: line
              }, index);
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CtaButtons, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
              as: ButtonLink/* ButtonLink */.Z,
              href: bot.inviteLink,
              buttonType: "callToAction",
              external: true,
              children: "Add to server"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
              as: ButtonLink/* ButtonLink */.Z,
              href: "/support",
              buttonType: "ghost",
              ghostHasBorder: true,
              external: true,
              children: "Get support"
            })]
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionHeader, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTitle, {
            kind: "subtitle",
            color: "primary",
            weight: "bold",
            children: bot.featureList.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
            children: bot.featureList.text
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Features, {
          "data-hide-on-mobile": true,
          columns: "two",
          children: bot.featureList.features.map(function (_ref4, index) {
            var name = _ref4.name,
                description = _ref4.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Feature, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureName, {
                kind: "body",
                color: "primary",
                children: name
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                kind: "caption",
                children: description
              })]
            }, "".concat(name, "-").concat(index));
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          "data-hide-on-desktop": "",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_SingleItemPaginator, {
            children: (0,toConsumableArray/* default */.Z)(Array.from({
              length: Math.ceil(bot.featureList.features.length / 3)
            })).map(function (_, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Features, {
                style: {
                  gridTemplateRows: '1fr 1fr 1fr'
                },
                columns: "one",
                children: bot.featureList.features.slice(index * 3, index * 3 + 3).map(function (_ref5, jIndex) {
                  var name = _ref5.name,
                      description = _ref5.description;
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Feature, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureName, {
                      kind: "body",
                      color: "primary",
                      children: name
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                      kind: "caption",
                      children: description
                    })]
                  }, "feat-".concat(name, "-").concat(index, "-").concat(jIndex));
                })
              }, "page-".concat(index));
            })
          })
        })]
      }), bot.reviews && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTitle, {
            kind: "subtitle",
            color: "primary",
            weight: "bold",
            children: bot.reviews.title
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_SingleItemPaginator, {
          children: bot.reviews.reviews.map(function (_ref6) {
            var content = _ref6.content,
                author = _ref6.author;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Review, {
              content: content,
              author: author
            }, author.name);
          })
        })]
      }), otherBots.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTitle, {
            kind: "subtitle",
            color: "primary",
            weight: "bold",
            children: "Check out our other bots"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BotList, {
          direction: {
            '@initial': 'column',
            '@dashboardMaxWidth': 'row'
          },
          children: otherBots.map(function (_ref7) {
            var _ref8 = (0,slicedToArray/* default */.Z)(_ref7, 2),
                pathName = _ref8[0],
                bot = _ref8[1];

            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_BotUpsellCard, {
                bot: bot,
                pathName: pathName
              })
            }, pathName);
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DonationUpsellSection, {
        direction: {
          '@initial': 'column',
          '@dashboardMaxWidth': 'row'
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
          title: "Help keep the project alive",
          subtitle: "Donate on Kofi to help support the apps we're developing."
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
          as: ButtonLink/* ButtonLink */.Z,
          href: "/kofi",
          buttonType: "callToAction",
          external: true,
          children: "Donate"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  }, bot.name
  /* diff key for each bot forces reset of state, etc */
  );
}

var __N_SSG = true;
/* harmony default export */ var _name_ = (BotPage);

/***/ }),

/***/ 2043:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bot/[name]",
      function () {
        return __webpack_require__(1106);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2746:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(1512);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(7211);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [385,774,888,179], function() { return __webpack_exec__(2043); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);